export default __webpack_public_path__ + "static/media/about-workshop-1.155cbe47.jpg";